"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIPaginator = _interopRequireDefault(require("UIComponents/paginator/UIPaginator"));

var LIST_QUERIES = _interopRequireWildcard(require("../../constants/reviews/ReviewsListQueries"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _ReviewStats = _interopRequireDefault(require("../../records/ReviewStats"));

var textPath = 'ecosystemMarketplaceCore.reviews.list';

var ReviewsList = function ReviewsList(_ref) {
  var buttonRow = _ref.buttonRow,
      excludedFilterOptions = _ref.excludedFilterOptions,
      onSortChange = _ref.onSortChange,
      onFilterChange = _ref.onFilterChange,
      onPageChange = _ref.onPageChange,
      listAlert = _ref.listAlert,
      maxWidth = _ref.maxWidth,
      queryState = _ref.queryState,
      ReviewRenderer = _ref.ReviewRenderer,
      reviews = _ref.reviews,
      reviewStats = _ref.reviewStats,
      showPagination = _ref.showPagination;
  var PAGE_KEY = LIST_QUERIES.PAGE_KEY,
      FILTER_KEY = LIST_QUERIES.FILTER_KEY,
      SORT_KEY = LIST_QUERIES.SORT_KEY,
      REVIEWS_PER_PAGE = LIST_QUERIES.REVIEWS_PER_PAGE;
  var reviewsCount = reviewStats.get('count');
  var pageCount = (0, _react.useMemo)(function () {
    return Math.ceil(reviewsCount / REVIEWS_PER_PAGE);
  }, [reviewsCount, REVIEWS_PER_PAGE]);
  var validFilters = (0, _react.useMemo)(function () {
    return reviewStats.getValidRatingFilters();
  }, [reviewStats]);
  var buildDropdown = (0, _react.useCallback)(function (textKey) {
    var options = Object.keys(LIST_QUERIES[textKey]).reduce(function (acc, option) {
      if (!excludedFilterOptions || !excludedFilterOptions.includes(option)) {
        acc.push({
          text: _I18n.default.text(textPath + "." + textKey + "." + option),
          value: option,
          disabled: textKey === FILTER_KEY && option !== LIST_QUERIES.FILTER.ALL && !validFilters.has(option)
        });
      }

      return acc;
    }, []);
    var onChange = textKey === SORT_KEY ? onSortChange : onFilterChange;
    return _react.default.createElement("span", null, _react.default.createElement("span", {
      style: {
        fontWeight: _misc.WEB_FONT_DEMI_BOLD_WEIGHT
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: textPath + "." + textKey + ".label"
    })), _react.default.createElement(_UISelect.default, {
      buttonUse: "transparent",
      menuWidth: 250,
      key: textKey,
      options: options,
      value: queryState.get(textKey),
      onChange: onChange
    }));
  }, [excludedFilterOptions, onSortChange, onFilterChange, FILTER_KEY, SORT_KEY, queryState, validFilters]);
  var renderedFilterDropdown = buildDropdown(FILTER_KEY);
  var renderedSortDropdown = buildDropdown(SORT_KEY);
  return _react.default.createElement("div", {
    style: {
      maxWidth: maxWidth
    }
  }, _react.default.createElement(_UIFlex.default, {
    justify: "between",
    align: "start"
  }, _react.default.createElement(_H.default, null, _react.default.createElement(_UITooltip.default, {
    placement: "right",
    title: _react.default.createElement(_FormattedHTMLMessage.default, {
      message: textPath + ".tooltip"
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".header",
    options: {
      count: reviewsCount
    }
  }))), buttonRow), _react.default.createElement(_UIFlex.default, {
    justify: "between",
    style: {
      borderBottom: "1px solid " + _colors.GREAT_WHITE
    }
  }, renderedFilterDropdown, renderedSortDropdown), _react.default.createElement(_UIFlex.default, {
    direction: "column",
    className: "m-bottom-8"
  }, listAlert, reviews.map(function (review) {
    return _react.default.createElement(ReviewRenderer, {
      key: review.get('id'),
      review: review
    });
  })), showPagination && _react.default.createElement(_UIPaginator.default, {
    maxVisiblePageButtons: 5,
    page: queryState.get(PAGE_KEY),
    pageCount: pageCount,
    onPageChange: onPageChange
  }));
};

ReviewsList.propTypes = {
  buttonRow: _propTypes.default.node,
  excludedFilterOptions: _propTypes.default.array,
  onSortChange: _propTypes.default.func.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  listAlert: _propTypes.default.node,
  maxWidth: _propTypes.default.number,
  queryState: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  ReviewRenderer: _propTypes.default.func.isRequired,
  reviews: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  reviewStats: _propTypes.default.instanceOf(_ReviewStats.default).isRequired,
  showPagination: _propTypes.default.bool
};
ReviewsList.defaultProps = {
  maxWidth: 750,
  showPagination: true
};
var _default = ReviewsList;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewsList.js
// module id = 413
// module chunks = 209 210 211 212